'use client';

import React, { useRef } from 'react';
import { noop } from 'utils/noop';
import { useEnterAnimation, useExitAnimation } from '@react-aria/utils';
import styles from './Dialog.module.css';

export type OverlayProps = {
  /** @deprecated transition duration in ms */
  transitionDuration?: number;
  /** Controls whether the overlay is showing */
  isShowing: boolean;
  /** Callback to indicate that the overlay should close */
  onRequestClose?: () => void;
  /** Z-index for the overlay */
  zIndex: number;
  /** Click handler for the overlay */
  onClick?: (event: React.MouseEvent<HTMLDivElement>) => void;
};

export function Overlay({
  isShowing,
  onRequestClose,
  zIndex,
  onClick = noop,
}: OverlayProps) {
  const ref = useRef(null);

  const isExiting = useExitAnimation(ref, isShowing);

  const isEntering = useEnterAnimation(ref, isShowing);

  if (!isShowing && !isExiting) {
    return null;
  }

  return (
    <div
      ref={ref}
      className={styles.overlay}
      data-entering={isEntering || undefined}
      data-exiting={isExiting || undefined}
      onClick={(event) => {
        onClick(event);
        onRequestClose?.();
      }}
      style={{ zIndex }}
    />
  );
}
